import React from 'react';
import ReactDOM from 'react-dom';
import Icon from '../Icon';

(async () => {
  var controlElements = document.querySelectorAll('[aria-controls]');
  if (!controlElements || controlElements.length == 0) return;

  for (var initiator of controlElements) {
    const target = document.getElementById(
      initiator.getAttribute('aria-controls')
    );
    if (!target) continue;

    const iconElem = document.createElement('div');
    if (iconElem) {
      iconElem.classList.add('icon-wrapper');
      ReactDOM.render(<Icon name="caret-down" />, iconElem);
      initiator.appendChild(iconElem);
    }

    const collapsed = target.classList.contains('collapsed');

    initiator.setAttribute('aria-expanded', !collapsed);
    target.setAttribute('aria-hidden', collapsed);

    target.classList.add('collapsible__content');

    if (!collapsed) {
      target.style.height = target.offsetHeight + 'px';
    } else {
      target.style.height = 0;
      target.style.visibility = 'hidden';
    }

    initiator.addEventListener('click', (e) => {
      var initiator = e.target;
      var target = document.getElementById(
        initiator.getAttribute('aria-controls')
      );
      target.classList.toggle('collapsed');

      const isCollapsed = target.classList.contains('collapsed');
      target.setAttribute('aria-hidden', isCollapsed);
      initiator.setAttribute('aria-expanded', !isCollapsed);

      if (!isCollapsed) {
        target.style.visibility = 'hidden';
        target.style.height = 'auto';

        const containerHeight = target.offsetHeight;

        target.style.height = 0;
        target.style.visibility = 'visible';

        setTimeout(() => {
          target.style.height = containerHeight + 'px';
          setTimeout(() => {
            target.style.height = 'fit-content';
          }, 200); //same duration as CSS-transition for animation to complete before adding fit-content
        }, 1);
      } else {
        target.style.height = 0;
        target.style.visibility = 'hidden';
      }
    });
  }
})();
